// extracted by mini-css-extract-plugin
export default {"favoritesIcon":"favorites-button_favoritesIcon__FoB+G","buttonWrapper":"favorites-button_buttonWrapper__YYU+U"};